<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781250015945_toc01#toctitle1" id="title1"><span>Thanks to</span></a></div>
<div class="p-c"><span>Lisa Moylett, Suzie Doore, Francine Toon, Imogen Olsen, Alice Laurent, Jessica Hische and Katie Davison.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span>Bronwen Salter-Murison, for designing and maintaining the Dandy Gilver website.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span>Sharron McColl, Dorothy Hall and Jeanette MacMillan of the Local History Dept in the Carnegie Library, Dunfermline and library user James Fraser, for information about old Dunfermline.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span>Louise Kelly, for unflagging support and unsettling craftwork.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span>And Neil.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-c"><span>One of the differences between academia and fiction-writing that I cherish most is no longer having to record and then cite all my sources, but I must mention the insanely detailed and unexpectedly riveting Lee E Gray, (2002), <em class="i">From Ascending Rooms to Express Elevators: A History of the Passenger Elevator in the Nineteenth Century</em> (Mobile, Ala: Elevator World, Inc.), without which Aitkens’ lift would still be a mystery to me.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781250015945_ack01.vue?46878b07